import { render, staticRenderFns } from "./addEditWidgetModal.vue?vue&type=template&id=eb658144&scoped=true"
import script from "./addEditWidgetModal.vue?vue&type=script&lang=js"
export * from "./addEditWidgetModal.vue?vue&type=script&lang=js"
import style0 from "./addEditWidgetModal.vue?vue&type=style&index=0&id=eb658144&prod&scoped=true&lang=css"
import style1 from "./addEditWidgetModal.vue?vue&type=style&index=1&id=eb658144&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb658144",
  null
  
)

export default component.exports